<script setup>
import page from '@/preload/data/indexPage.json'
</script>

<template>
  <div v-if="page" :class="page.withoutVerticalSpace ? '' : 'mt-10'">
    <cms-block-renderer :blocks="page.blocks" />
  </div>
</template>
